recommendationTemplate = require '../recommendation.html.mustache'
smallWidgetTemplate = require '../small_widget.html.mustache'

class Groupon.FollowMerchantModal

  constructor: (@el, @data, @csrf) ->
    @rootUrl = '/merchant-page'
    @$modal = $ @el
    @$modalFollowContainers = @$modal.find '.follow-container'
    @$modalRecommendationContainers = @$modal.find '.recommendation-container'

    @isMakingAPIRequest = {}

  openModal: ->
    @addFollowAndRecommendationData @data

    MPP.Modal.open '#follow-merchant-nearby-places-modal'
    GIG.Utils.truncateElements $('#follow-merchant-nearby-places-modal')

    @initModalBindings()
    @lazyLoadImages()

  addFollowAndRecommendationData: (data) ->
    _.each @$modalFollowContainers, (followContainer) ->
      $followContainer = $ followContainer
      closestPlaceCard = $followContainer.closest '.deal-card'
      {placeId} = $(closestPlaceCard).data()

      followData = data?[placeId]?['follow']
      templateData =
        placeId: placeId
        presentedFollowCount: followData?.presentedFollowCount ? '0'

      templateData.translate = templateData.t = -> (text) -> I18n.translate text

      html = smallWidgetTemplate.render templateData
      $followContainer.html html

    _.each @$modalRecommendationContainers, (recommendationContainer) ->
      $recommendationContainer = $ recommendationContainer
      closestPlaceCard = $recommendationContainer.closest '.deal-card'
      {placeId} = $(closestPlaceCard).data()

      recommendationData = data?[placeId]?['recommendation']
      return unless recommendationData?.showToUser

      templateData =
        total: recommendationData.total
        percentage: recommendationData.percentage

      html = recommendationTemplate.render templateData
      $recommendationContainer.html html

  lazyLoadImages: ->
    @$modal.find('.lazy-loaded-image').each (position, imageElement) ->
      $image = $(imageElement)
      $image.attr 'src', $image.attr('lazy-load-src')

  initModalBindings: ->
    @$modalFollowButtons = @$modalFollowContainers.find '.follow-text-container'
    @$modalTextContainers = @$modalFollowContainers.find '.follow-count-container'
    @$modalUnfollowButtons = @$modalFollowContainers.find '.unfollow-text-container'

    @$modalTextContainers.click @followMerchant
    @$modalFollowButtons.click @followMerchant
    @$modalUnfollowButtons.click @unfollowMerchant

  modalSwitchFollowingStatus: ($container) ->
    $container.find('.unfollow-text-container').toggleClass('hide')
    $container.find('.follow-text-container').toggleClass('hide')
    $container.find('.follow-count-container').toggleClass('hide')

  followMerchant: (e) =>
    e.preventDefault()
    {placeId, closestFollowContainer} = @getNecessaryClickInformation(e)

    @makeFollowAPICall placeId, "#{@rootUrl}/follow-merchant", $(closestFollowContainer)

  unfollowMerchant: (e) =>
    e.preventDefault()
    {placeId, closestFollowContainer} = @getNecessaryClickInformation(e)

    @makeFollowAPICall placeId, "#{@rootUrl}/follow-merchant/delete", $(closestFollowContainer)

  getNecessaryClickInformation: (e) ->
    $clickedButton = $(e.target)

    closestFollowContainer = $clickedButton.closest '.follow-content'
    closestPlaceCard = $clickedButton.closest '.deal-card'
    {placeId} = $(closestPlaceCard).data()

    return { placeId, closestFollowContainer }

  makeFollowAPICall: (placeId, url, $container) ->
    return if @isMakingAPIRequest[placeId]
    @isMakingAPIRequest[placeId] = true

    @modalSwitchFollowingStatus $container

    obj =
      _csrf: @csrf
      placeId: placeId

    $.ajax
      url: url
      type: 'POST'
      contentType: 'application/json'
      dataType: 'json'
      data: JSON.stringify obj
      error: =>
        @modalSwitchFollowingStatus $container
      complete: =>
        @isMakingAPIRequest[placeId] = false
